import { type ElasticsearchQuery, type FacetFieldConfig } from '@searchkit/api';

import { sportsDataHistoryRequiredQuery, validEventOverviewQuery } from '~/apps/product-plus/search-domain/queries';
import { type SearchDomainContext, type SearchRuntimeSortingConfig } from '~/apps/product-plus/search-domain/types';

const eventOverviewResultAttributes = [
  'eventDisplayName',
  'subeventName',
  'subeventStartTime',
  'teamData',
  'subeventId',
  'categoryGroupName',
];

export function getEventOverviewBaseFilters(_context: SearchDomainContext) {
  const baseFilters: ElasticsearchQuery[] = [validEventOverviewQuery, sportsDataHistoryRequiredQuery];
  return baseFilters;
}

export function getEventOverviewFacetAttributes(): FacetFieldConfig[] {
  return [
    { attribute: 'subeventId', field: 'subeventId', type: 'string' },
    { attribute: 'eventDisplayName', field: 'eventDisplayName', type: 'string' },
    { attribute: 'marketDisplayName', field: 'marketDisplayName', type: 'string' },
    { attribute: 'teamData.away.name', field: 'teamData.away.name.keyword', type: 'string' },
    { attribute: 'teamData.away.nickName', field: 'teamData.away.nickName.keyword', type: 'string' },
    { attribute: 'teamData.away.shortName', field: 'teamData.away.shortName.keyword', type: 'string' },
    { attribute: 'teamData.home.name', field: 'teamData.home.name.keyword', type: 'string' },
    { attribute: 'teamData.home.nickName', field: 'teamData.home.nickName.keyword', type: 'string' },
    { attribute: 'teamData.home.shortName', field: 'teamData.home.shortName.keyword', type: 'string' },
    { attribute: 'marketClassification', field: 'marketClassification', type: 'string' },
  ];
}

export function getEventOverviewSearchSettings() {
  return {
    results: eventOverviewResultAttributes,
    search: [],
    highlights: [],
  };
}

export function getEventOverviewSorting(): SearchRuntimeSortingConfig {
  return {
    options: [{ field: 'subeventId', label: 'Subevent ID', order: 'asc' }],
  };
}
